import React from 'react';
import { Modal, Space, Alert, Row, Col, Upload, Button, Typography, Table } from 'antd';
import { UploadOutlined, FileTextOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function BulkUploadAttendanceModal({
  open,
  bulkType,
  parsedRecords,
  bulkUploading,
  onFileUpload,
  onDownloadAttendanceTemplate,
  onDownloadMappingTemplate,
  onSubmitBulk,
  onCancel
}) {
  return (
    <Modal
      title={
        <span>
          <UploadOutlined style={{ marginRight: 8, color: 'var(--primary-color)' }} />
          Bulk Upload {bulkType === 'ATTENDANCE' ? 'Attendance Records' : 'Biometric Mappings'}
        </span>
      }
      open={open}
      onOk={onSubmitBulk}
      confirmLoading={bulkUploading}
      okText={`Upload ${parsedRecords.length} Records`}
      onCancel={onCancel}
      width={720}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: '100%' }} size="medium">
        <Alert
          message="Instructions & Template Download"
          description={
            <div>
              Select a CSV or JSON file containing bulk entries. You can download the pre-formatted CSV template below.
              <div style={{ marginTop: 4, fontSize: 11, color: '#555' }}>
                <b>Valid Status Codes:</b> <code>P</code> (PRESENT), <code>A</code> (ABSENT), <code>HD</code> (HALF_DAY), <code>OT</code> (OVERTIME), <code>L</code> (LATE), <code>LE</code> (LEAVE_EARLY).
              </div>
            </div>
          }
          type="info"
          showIcon
        />

        <Row justify="space-between" align="middle">
          <Col>
            <Upload
              beforeUpload={onFileUpload}
              accept=".csv, .json"
              showUploadList={false}
            >
              <Button icon={<FileTextOutlined />}>Select CSV / JSON File</Button>
            </Upload>
          </Col>
          <Col>
            <Button
              type="primary"
              ghost
              icon={<DownloadOutlined />}
              onClick={bulkType === 'ATTENDANCE' ? onDownloadAttendanceTemplate : onDownloadMappingTemplate}
            >
              Download Sample CSV Template
            </Button>
          </Col>
        </Row>

        {parsedRecords.length > 0 && (
          <div>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>
              Parsed Records Preview ({parsedRecords.length} records ready):
            </Text>
            <Table
              dataSource={parsedRecords.slice(0, 5)}
              rowKey={(_, idx) => idx}
              size="small"
              pagination={false}
              bordered
              scroll={{ x: 'max-content' }}
              columns={
                bulkType === 'ATTENDANCE'
                  ? [
                      { title: 'Type', dataIndex: 'person_type' },
                      { title: 'Staff ID', dataIndex: 'staff_id' },
                      { title: 'Cand ID', dataIndex: 'candidate_id' },
                      { title: 'Bio ID', dataIndex: 'biometric_user_id' },
                      { title: 'Date', dataIndex: 'attendance_date' },
                      { title: 'Status', dataIndex: 'status' }
                    ]
                  : [
                      { title: 'Bio User ID', dataIndex: 'biometric_user_id' },
                      { title: 'Type', dataIndex: 'person_type' },
                      { title: 'Staff ID', dataIndex: 'staff_id' },
                      { title: 'Cand ID', dataIndex: 'candidate_id' },
                      { title: 'Status', dataIndex: 'status' }
                    ]
              }
            />
            {parsedRecords.length > 5 && (
              <Text type="secondary" style={{ fontSize: 11, marginTop: 4, display: 'block' }}>
                Showing first 5 of {parsedRecords.length} total records...
              </Text>
            )}
          </div>
        )}
      </Space>
    </Modal>
  );
}
